import { API } from 'aws-amplify';
import requestBuilder from '@/services/graphql/requestBuilder';
import { GRAPHQL_TYPES } from '@/constants/cores';

async function trackCollectionView(variables) {
  const query = new requestBuilder({
    requestName: 'trackCollectionView',
    requestType: GRAPHQL_TYPES.MUTATION,
    requestVariables: {
      collectionId: 'String!',
      viewType: 'CollectionViewType',
    },
    variables,
  }).buildQuery();
  const res = await API.graphql({
    query,
    variables,
  });
  return res;
}

export default {
  trackWSCollectionView(variables) {
    return trackCollectionView({
      ...variables,
      viewType: 'workspace',
    });
  },
  trackCommCollectionView(variables) {
    return trackCollectionView({
      ...variables,
      viewType: 'community',
    });
  },
};
